import styled from 'styled-components'

export const MeetsAgesContainer = styled.div`
  margin-top: 40px;

  display: flex;
  flex-direction: column;
  gap: 15px;

  .HomeFiltersAgeSelect {
    max-width: 100%;

    div {
      margin-top: 0;
    }

    &.noSelectAgeError {
      div {
        border: 1px solid red;
      }
    }
  }
`